import React from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import { SbTag, SbTooltip } from "uiCore";
import useShortlistStore, { useIsShortlisted } from "Store/useShortlistStore";

const notifyTooltip = (entry) => {
  if (!entry) return "";
  const { notifyEmployee, notifyLineManager, notifyHiringManager } = entry;
  const notified = [
    notifyEmployee && "Employee",
    notifyLineManager && "Line Manager",
    notifyHiringManager && "Hiring Manager",
  ].filter(Boolean);
  if (!notified.length) return "Shortlisted silently — no one was notified.";
  const list = notified.length > 1
    ? `${notified.slice(0, -1).join(", ")} and ${notified[notified.length - 1]}`
    : notified[0];
  return `${list} ${notified.length > 1 ? "were" : "was"} notified.`;
};

// Renders nothing unless this (roleId, personId) pair has been shortlisted —
// used across the candidate tables and skill-gap accordion so shortlisting
// from the Candidate Profile view (see CandidateProfileV2.jsx) is reflected
// everywhere that pair is listed. API-backed rows pass `shortlisted` as a
// boolean (from /role-successor-analytics, the JD's own shared shortlist —
// one row per role, so this reads the same regardless of which occupant's
// link the pair was reached through) and the backend is then the ONLY
// source of truth — a stale session-store entry must not resurrect a pair
// the API says is not shortlisted. The store decides only when the flag is
// absent: mock roles and the redeployment/workforce draft flows, whose
// shortlists never hit the API until the plan is submitted.
const ShortlistTag = ({ roleId, personId, shortlisted, style }) => {
  const isStoreShortlisted = useIsShortlisted(roleId, personId);
  const entry = useShortlistStore((state) => state.shortlisted[`${roleId}::${personId}`]);
  const isShortlisted = typeof shortlisted === "boolean" ? shortlisted : isStoreShortlisted;
  if (!isShortlisted) return null;
  return (
    <SbTooltip content={entry ? notifyTooltip(entry) : "Shortlisted for this role."}>
      <SbTag color="success" icon={<CheckCircleFilled />} style={{ marginLeft: 6, ...style }}>
        Shortlisted
      </SbTag>
    </SbTooltip>
  );
};

export default ShortlistTag;
